import React from 'react';
import getTranslatedInnerSvg from '../../../utils/svgUtils/translationProcessor';
import { GetLinks } from '../../LinksAndCurrentLocation/LinksAndCurrentLocation';
const ItemImage = ({ item, isMobileOn }) => (
        <PreviewImage item={item} isMobileOn={isMobileOn} />
);
const PreviewImage = ({ item, isMobileOn }) => {
    if (isMobileOn) {
        if (item.svgContentMobile && item.svgViewBox) {
            return (
                <svg
                    dangerouslySetInnerHTML={getTranslatedInnerSvg(item.svgContentMobile, getRecType(item))}
                    className="draggable-image"
                    viewBox={setViewboxMobile(item)}
                />
            );
        }
        return null;
    }
    
    if (item.svgContent && item.svgViewBox) {
        return (
            <svg
                dangerouslySetInnerHTML={getTranslatedInnerSvg(item.svgContent, getRecType(item))}
                className="draggable-image"
                viewBox={setViewbox(item)}
            />
        );
    }
    
    return null;
};

const setViewbox = item => item.svgViewBox;

const setViewboxMobile = item => item.svgViewBoxMobile;

function getRecType(item) {
    if (item.type === 'newsSection') {
        const recType = JSON.parse(item.config);
        return recType["Type"];
    } else {
        return null;
    }
}

export default ItemImage;